import React from 'react'
import Modal from 'react-bootstrap/Modal'

const OptionsModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      style={{
        userSelect: 'none',
      }}
      size={20}
      //   backdrop='static'
      centered
    >
      <Modal.Body className=''>
        <div className='label' style={{ fontSize: '18px' }}>
          Tesis Özellikleri
        </div>
        {props?.options?.map((option, i) => (
          <div className='optionItem' key={i} onClick={() => {}}>
            {`* ${option}`}
          </div>
        ))}
        <div
          style={{ position: 'absolute', top: '15px', right: '15px' }}
          onClick={props.onHide}
        >
          X
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default OptionsModal
